import u, { useMemo as m } from "react";
import { Selector as s } from "../Selector/Selector.js";
import { locales as a } from "./locales.min.js";
function g(o) {
  const {
    value: n,
    onChange: e
  } = o, l = m(() => a.find((t) => t.value === n), [n]), r = (t, c) => {
    e == null || e(t.value, c);
  };
  return /* @__PURE__ */ u.createElement(
    s,
    {
      ...o,
      testId: "language-selector",
      options: a,
      value: l,
      onChange: r
    }
  );
}
export {
  g as LanguageSelector
};
//# sourceMappingURL=LanguageSelector.js.map
